import React, { useEffect, useState, useRef, useCallback } from 'react'
import styled from 'styled-components'
import DotsMenu from 'src/components/icons/DotsMenu'
import IconButton from 'src/components/atoms/IconButton'

export const MenuTrigger = (props) => {
  const { trigger, open, handleClose, handleOpen } = props
  const DropdownRef = useRef(null)
  const TriggerButtonContainerRef = useRef(null)
  const forceTopOffset = props.forceTopOffset ? Number(props.forceTopOffset) : null
  const [offsets, setOffsets] = useState({
    bottom: 0,
    top: 0,
    left: 0,
    right: 0
  })
  const [dropdownSize, setDropdownSize] = useState({
    width: 0,
    height: 0
  })

  const [triggerButtonContainerSize, setTriggerButtonContainerSize] = useState({
    width: 0,
    height: 0
  })

  const handleCloseIfOpen = useCallback(
    () => open && handleClose()
  )

  const saveOffsets = event => {
    setOffsets({
      bottom: innerHeight - event.clientY,
      top: forceTopOffset ? forceTopOffset : event.clientY,
      left: event.clientX,
      right: innerWidth - event.clientX
    })
  }

  const saveDropdownSize = ref => {
    setDropdownSize({
      width: ref.current.clientWidth,
      height: ref.current.clientHeight
    })
  }

  const saveTriggerButtonContainerSize = ref => {
    setTriggerButtonContainerSize({
      width: ref.current.clientWidth,
      height: ref.current.clientHeight
    })
  }

  useEffect(() => {
    if (open) {
      addEventListener('click', handleCloseIfOpen)
    } else {
      removeEventListener('click', handleCloseIfOpen)
    }
  }, [open])

  const handleContainerClick = event => {
    event.stopPropagation()
    saveOffsets(event)
    saveDropdownSize(DropdownRef)
    saveTriggerButtonContainerSize(TriggerButtonContainerRef)
  }

  return (
    <MenuContainer
      offsets={offsets}
      dropdownSize={dropdownSize}
      triggerButtonContainerSize={triggerButtonContainerSize}
      open={open}
      onClick={handleContainerClick}
      forceTopOffset={forceTopOffset}
    >
      <div ref={TriggerButtonContainerRef} className='menu__trigger-button' onClick={handleOpen}>
        {trigger}
      </div>
      <div className='menu__children-container'>
        <div ref={DropdownRef} className='menu__children-container--inner'>
          {props.children}
        </div>
      </div>
    </MenuContainer>
  )
}

export const MenuItem = styled.div`
  cursor: pointer;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  box-sizing: border-box;
  padding: 12px 16px;
  white-space: nowrap;
  transition: 10ms cubic-bezier(0, 0, 0.2, 1) 10ms;
  color: ${props => props.theme.palette.text.main};
  
  a {
    color: ${props => props.theme.palette.text.main};
  }
  
  &:hover,
  &:focus {
    background-color: ${props => props.theme.palette.common.catskillWhite};
    color: ${props => props.theme.palette.primary.main};
    
    a {
      color: ${props => props.theme.palette.primary.main};
    }
  }
  
  &:active {
    background-color: ${props => props.theme.palette.common.alto};
    color: ${props => props.theme.palette.primary.dark};
    
    a {
      color: ${props => props.theme.palette.primary.dark};
    }
  }
`

const MenuContainer = styled.div`
  display: inline-block;
  position: relative;
  font-family: ${props => props.theme.typography.fontFamily};
 
  .menu__children-container {
    position: absolute;
    top: ${props => {
      switch (true) {
        case !!props.forceTopOffset:
          return `${props.forceTopOffset}px`
        case props.offsets.bottom < props.dropdownSize.height:
          return `${props.triggerButtonContainerSize.height - props.dropdownSize.height}px`
        default:
          return '0'
      }
    }};
    left: ${props => {
      switch (true) {
        case props.offsets.right < props.dropdownSize.width:
          return `${props.triggerButtonContainerSize.width - props.dropdownSize.width}px`
        default:
          return '0'
      }
    }};
    min-width: ${props => props.open ? '100%' : '0'};
    min-height: ${props => props.open ? '100%' : '0'};
  }
 
  .menu__children-container--inner {
    visibility: ${props => props.open ? 'visible' : 'hidden'};
    background-color: ${props => props.theme.palette.common.titanWhite};
    box-shadow: ${props => props.theme.shadows.paper};
    border-radius: 5px;
    position: fixed;
    z-index: ${props => props.open ? props.theme.zIndex.dropdown : '0'};
    padding: 6px 0;
    min-width: ${props => props.open ? 'auto' : '0'};
    min-height: ${props => props.open ? 'auto' : '0'};
    transition: 10ms cubic-bezier(0, 0, 0.2, 1) 10ms;
  }
 
 ${MenuItem} {
   visibility: ${props => props.open ? 'visible' : 'hidden'};
 }
`

MenuTrigger.defaultProps = {
  trigger: <IconButton size='small'><DotsMenu /></IconButton>,
  open: false,
  handleClose: () => {},
  handleOpen: () => {}
}

export default MenuTrigger
